import React from 'react';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';

import styles from './ReferralPromoModal.css';

export interface ReferralPromoModalProps {
    onClose(): void;
    onClick(): void;
    onShow(): void;
    imageUrl: string;
    title: string;
    text: string;
    buttonText: string;
}

export function ReferralPromoModal({ onClick, onClose, onShow, imageUrl, text, title, buttonText }: ReferralPromoModalProps) {
    return (
        <WhatsNewDialog
            className={styles.root}
            textClassName={styles.text}
            imageUrl={imageUrl}
            title={title}
            text={text}
            primaryButtonText={buttonText}
            onShow={onShow}
            onClick={onClick}
            onClose={onClose}
            buttonTheme="vk"
            dialogSize="tiny"
            qaId="referral-modal-promo"
            isRebranding
        />
    );
}
